/**
 * 打印模板配置文件
 * 按银行类型分组：
 * js - 建设银行
 * ny - 农业银行
 * wx - 微信
 * yz - 邮政银行
 * zg - 中国银行
 * 
 * 模板类型说明：
 * 01 - 横版模板
 * 02 - 竖版模板
 * 03 - 电子版模板
 */

// 所有模板路径配置
const templatePaths = {
  // 建设银行模板
  js01: 'template/js01.fr3', // 建设银行横版
  js02: 'template/js02.fr3', // 建设银行竖版
  js03: 'template/js03.fr3', // 建设银行竖版
  js04: 'template/js04.fr3', // 建设银行电子版横版
  // 农业银行模板
  ny02: 'template/ny02.fr3', // 农业银行竖版
  ny03: 'template/ny03.fr3', // 农业银行电子版
  
  // 微信模板
  wx03: 'template/wx03.fr3', // 微信电子版
  wx04: 'template/wx04.fr3', // 微信电子换行版
  
  // 邮政银行模板
  yz02: 'template/yz02.fr3', // 邮政银行竖版
  yz03: 'template/yz03.fr3', // 邮政银行电子版
  yz04: 'template/yz04.fr3', // 邮政银行电子版总和
  
  // 中国银行模板
  zg01: 'template/zg01.fr3', // 中国银行横版
  zg03: 'template/zg03.fr3',  // 中国银行电子版

  // 农业银行竖版
  nyzz02: 'template/nyzz02.fr3', // 农业银行竖版
  nyzz03: 'template/nyzz03.fr3', // 农业银行电子版

  // GS银行模板
  gs01: 'template/gs01.fr3', // 工商银行竖版
  gs03: 'template/gs03.fr3', // 工商银行电子版

  // 平安银行模板
  pa01: 'template/pa01.fr3', // 平安银行纸质版-竖版
  pa02: 'template/pa02.fr3', // 平安银行纸质版-横版
  pa03: 'template/pa03.fr3', // 平安银行电子版1

  // 兴业银行模板
  xy01: 'template/xy01.fr3', // 兴业银行电子不带二维码
  xy02: 'template/xy02.fr3', // 兴业银行电子带二维码

  // 交通银行模板
  jt01: 'template/jt01.fr3', // 交通银行横版（全字段）
  jt02: 'template/jt02.fr3', // 交通银行竖版（无对方账号/户名/交易时间）
};

// 模板类型
const templateTypes = {
  '01': '横版',
  '02': '竖版',
  '03': '电子版',
  '04': '电子版(总和)'
};

// 按银行类型分组的模板
const templatesByBank = {
  js: { // 建设银行
    templates: [
      { id: 'js01', name: '建设银行横版', type: '01', path: templatePaths.js01 },
      { id: 'js02', name: '建设银行竖版', type: '02', path: templatePaths.js02 },
      { id: 'js03', name: '建设银行电子', type: '03', path: templatePaths.js03 },
      { id: 'js04', name: '建设银行电子版横版', type: '04', path: templatePaths.js04 }
    ],
    defaultTemplate: 'js01'
  },
  ny: { // 农业银行
    templates: [
      { id: 'ny02', name: '农业银行竖版', type: '02', path: templatePaths.ny02 },
      { id: 'ny03', name: '农业银行电子版', type: '03', path: templatePaths.ny03 }
    ],
    defaultTemplate: 'ny03'
  },
  wx: { // 微信
    templates: [
      { id: 'wx03', name: '微信电子版', type: '03', path: templatePaths.wx03 },
      { id: 'wx04', name: '微信电子换行版', type: '04', path: templatePaths.wx04 }
    ],
    defaultTemplate: 'wx03'
  },
  yz: { // 邮政银行
    templates: [
      { id: 'yz02', name: '邮政银行竖版', type: '02', path: templatePaths.yz02 },
      { id: 'yz03', name: '邮政银行电子版', type: '03', path: templatePaths.yz03 },
      { id: 'yz04', name: '邮政银行电子版总和', type: '04', path: templatePaths.yz04 }
    ],
    defaultTemplate: 'yz02'
  },
  zg: { // 中国银行
    templates: [
      { id: 'zg01', name: '中国银行横版', type: '01', path: templatePaths.zg01 },
      { id: 'zg03', name: '中国银行电子版', type: '03', path: templatePaths.zg03 }
    ],
    defaultTemplate: 'zg01'
  },
  nyzz: { // 农业银行
    templates: [
      { id: 'nyzz02', name: '农业银行竖版', type: '02', path: templatePaths.nyzz02 },
      { id: 'nyzz03', name: '农业银行电子版', type: '03', path: templatePaths.nyzz03 }
    ],
    defaultTemplate: 'nyzz02'
  },
  gs: { // GS银行
    templates: [
      { id: 'gs01', name: '工商银行横版', type: '01', path: templatePaths.gs01 },
      { id: 'gs03', name: '工商银行电子版', type: '03', path: templatePaths.gs03 }
    ],
    defaultTemplate: 'gs01'
  },
  pa: { // 平安银行
    templates: [
      { id: 'pa01', name: '平安银行纸质版-竖版', type: '02', path: templatePaths.pa01 },
      { id: 'pa02', name: '平安银行纸质版-横版', type: '01', path: templatePaths.pa02 },
      { id: 'pa03', name: '平安银行电子版1', type: '03', path: templatePaths.pa03 }
    ],
    defaultTemplate: 'pa01'
  },
  xy: { // 兴业银行
    templates: [
      { id: 'xy01', name: '兴业银行-电子(不带二维码)', type: '01', path: templatePaths.xy01 },
      { id: 'xy02', name: '兴业银行-电子(带二维码)', type: '02', path: templatePaths.xy02 }
    ],
    defaultTemplate: 'xy01'
  },
  jt: { // 交通银行
    templates: [
      { id: 'jt01', name: '交通银行横版', type: '01', path: templatePaths.jt01 },
      { id: 'jt02', name: '交通银行竖版', type: '02', path: templatePaths.jt02 }
    ],
    defaultTemplate: 'jt01'
  }
};

// 获取指定银行的所有模板
const getTemplatesByBank = (bankCode) => {
  return templatesByBank[bankCode] || { templates: [], defaultTemplate: null };
};

// 获取指定模板ID的路径
const getTemplatePath = (templateId) => {
  return templatePaths[templateId] || null;
};

// 获取指定银行的默认模板ID
const getDefaultTemplateId = (bankCode) => {
  const bankTemplates = templatesByBank[bankCode];
  return bankTemplates ? bankTemplates.defaultTemplate : null;
};

// 获取模板类型名称
const getTemplateTypeName = (typeCode) => {
  return templateTypes[typeCode] || '未知类型';
};

export default {
  templatePaths,
  templateTypes,
  templatesByBank,
  getTemplatesByBank,
  getTemplatePath,
  getDefaultTemplateId,
  getTemplateTypeName
};
